import {EntityFactory, Reducer} from '@modifi/redux'
import {
  getAuthenticatedThemisClient,
  OnboardingUserAndCompanyView,
} from '@modifi/onboarding-api-clients'

type State = Record<string, any>
export type OnboardingUserWithoutCompanyView = OnboardingUserAndCompanyView & {company: never}

const client = getAuthenticatedThemisClient()

const {actions, reducer, selectors, actionTypes} = EntityFactory({
  actionNamePrefix: `data/user/entity`,
  rootSelector: state => state?.data?.user,
  fetchRequest: (): Promise<OnboardingUserAndCompanyView> =>
    client.User.fetch().then(res => res.data()),
})

export const userActionTypes = actionTypes!

export default reducer as Reducer

export const selectUser = (state: State): OnboardingUserWithoutCompanyView | null | undefined =>
  selectors.selectEntity(state) as OnboardingUserWithoutCompanyView | null | undefined

export const aFetchUser = (): any => actions?.fetch({})
